import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from 'components/drawers/utility-drawer/utility-drawer.component';
import { Box, Grid, Typography, Link as MuiLink, Stack } from '@mui/material';
import { useGetItemQuery } from 'api/ordering-service/ordering-service';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Link } from 'react-router-dom';
import ItemDetailCard from './items-card/item-detail-card.component';
import ItemDisplayInfoTabs from './items-card/item-display-info-tabs.component';
import { ArrowForward } from '@mui/icons-material';
import { useMemo } from 'react';

const ItemQuickDetailsDrawer = ({ open, close, drawerData }) => {
  const { t } = useTranslation();
  const { currentData: itemData, isFetching } = useGetItemQuery({
    itemId: drawerData?.itemId ?? skipToken,
  });
  const cancel = () => {
    close();
  };

  const modifiedData = useMemo(
    () => ({
      ...itemData,
      displayInfo: itemData?.displayInfo?.map(({ languageCode, ...rest }) => ({
        ...rest,
        langCode: languageCode,
      })),
    }),
    [itemData],
  );

  return (
    <UtilityDrawer
      isLoading={isFetching}
      open={open}
      onClose={cancel}
      data-testid="itemDetailsQuickDrawer.Drawer"
      title={t('drawer.productsDrawer.items.singularTitle')}
    >
      <UtilityDrawerBody>
        <Stack spacing={2}>
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Box display={'flex'} justifyContent={'flex-end'}>
                <MuiLink
                  sx={{ display: 'flex', alignItems: 'flex-end' }}
                  component={Link}
                  to={`/menus/items/${itemData?.itemId}`}
                >
                  <Typography variant="body2">
                    {t('drawer.productsDrawer.items.viewFullDetails')}
                  </Typography>
                  <ArrowForward sx={{ mr: 1, ml: 1 }} fontSize="small" />
                </MuiLink>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ '&&': { mt: 0, ml: -2 } }}>
            <Grid size={{ xs: 12 }}>
              <ItemDetailCard itemData={itemData} />
            </Grid>
            {itemData && Array.isArray(modifiedData?.displayInfo) && (
              <Grid size={{ xs: 12 }}>
                <ItemDisplayInfoTabs displayInfo={modifiedData?.displayInfo} />
              </Grid>
            )}
          </Grid>
        </Stack>
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default ItemQuickDetailsDrawer;
